import { Link } from "react-router-dom";
import { CASES, HOT_ARCHIVE, CATEGORIES } from "@/mocks/archive";

const bySlug = (s: string) => CASES.find((c) => c.slug === s)!;

function catName(slug: string) {
  return CATEGORIES.find((c) => c.slug === slug)?.name || "";
}

export default function Featured() {
  const hot = HOT_ARCHIVE.map(bySlug).slice(0, 5);
  const fresh = [...CASES]
    .sort((a, b) => (a.published < b.published ? 1 : -1))
    .filter((c) => !HOT_ARCHIVE.includes(c.slug))
    .slice(0, 3);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600 uppercase">
              <span className="h-px w-8 bg-primary-400" /> Hot &amp; Fresh
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              本周瓜田头条
            </h2>
          </div>
          <span className="hidden sm:inline-flex items-center gap-2 text-xs text-foreground-500 rounded-full border border-background-300/70 bg-background-100 px-3 py-1.5">
            <i className="ri-flashlight-line text-accent-500" /> 热度由事件发酵程度综合估算
          </span>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.6fr_1fr]">
          {/* 左侧热门榜 */}
          <div className="divide-y divide-background-200/90 rounded-2xl border border-background-300/70 bg-background-100">
            {hot.map((item, i) => (
              <article key={item.slug} className="group">
                <Link to={`/case/${item.slug}`} className="flex items-start gap-4 md:gap-5 p-4 md:p-5 transition-colors hover:bg-background-200/50">
                  <span className={`font-heading text-3xl md:text-4xl font-black leading-none tabular-nums ${
                    i === 0 ? "text-primary-600" : i === 1 ? "text-accent-600" : "text-foreground-300"
                  }`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-800">{catName(item.category)}黑料</span>
                      <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400"><i className="ri-time-line" />{item.published}</span>
                      <span className="inline-flex items-center gap-1 text-[11px] text-accent-600"><i className="ri-fire-fill" />热度 {item.heat}/5</span>
                    </div>
                    <h3 className="mt-1.5 font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-1">
                      {item.title}
                    </h3>
                    <p className="mt-1 hidden md:block text-sm text-foreground-600 line-clamp-1">{item.excerpt}</p>
                  </div>
                  <i className="ri-arrow-right-up-line mt-1 text-lg text-foreground-300 transition-all group-hover:text-primary-600" />
                </Link>
              </article>
            ))}
          </div>

          {/* 右侧最新入库 */}
          <aside className="flex flex-col rounded-2xl border border-background-300/70 bg-background-100 p-5 md:p-6">
            <div className="flex items-center gap-2">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-accent-100 text-accent-700"><i className="ri-database-2-line" /></span>
              <h3 className="font-heading text-base font-bold text-foreground-950">最新入库档案</h3>
            </div>
            <div className="mt-4 flex flex-col gap-3">
              {fresh.map((item) => (
                <Link key={item.slug} to={`/case/${item.slug}`} className="group rounded-lg border border-background-300/60 bg-background-50 p-3.5 transition-colors hover:border-accent-300">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-[11px] text-foreground-400">{item.published}</span>
                    <span className="rounded bg-accent-50 px-1.5 py-0.5 text-[10px] text-accent-700">{catName(item.category)}黑料</span>
                  </div>
                  <h4 className="mt-1.5 font-medium text-sm leading-6 text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2">
                    {item.title}
                  </h4>
                </Link>
              ))}
            </div>
            <Link
              to="/archive"
              className="mt-auto pt-5 inline-flex items-center justify-center gap-1.5 rounded-full border border-primary-300 bg-primary-50 px-4 py-2.5 text-sm font-semibold text-primary-700 hover:bg-primary-100 transition-colors whitespace-nowrap"
            >
              进入完整档案库 <i className="ri-arrow-right-line text-sm" />
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}